import { render } from "./KqAgreementDetails.vue?vue&type=template&id=dd9e14d8&scoped=true"
import script from "./KqAgreementDetails.vue?vue&type=script&lang=js"
export * from "./KqAgreementDetails.vue?vue&type=script&lang=js"

import "./KqAgreementDetails.vue?vue&type=style&index=0&id=dd9e14d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9e14d8"]])

export default __exports__